import { inject, Injectable } from '@angular/core';
import { TicketApi } from './ticket.api';
import { Observable } from 'rxjs';

export interface TicketResponse {
  id: string;
  drawId: string;
  pickedUp: boolean;
  memberCount: number;
  extraTickets: number | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  private readonly api = inject(TicketApi);

  public getTicketFromDrawAndRegistration(drawId: string, registrationId: string): Observable<TicketResponse> {
    return this.api.getTicketByDrawIdAndRegistrationId(drawId, registrationId);
  }

  public getTicket(identifier: string, drawId: string): Observable<TicketResponse> {
    return this.api.getTicketByIdentifierAndDrawId(identifier, drawId);
  }

  public setPickedUp(identifier: string): Observable<TicketResponse> {
    return this.api.patchTicketPickedUpState(identifier, true);
  }
}
